<template>
  <ZDialog v-model:open="isDialogOpen">
    <ZDialogContent class="lg:max-w-[625px] lg:overflow-y-hidden max-w-screen-lg overflow-y-scroll h-full lg:h-auto">
      <ZDialogHeader>
        <ZDialogTitle>{{ $t('dictionary.label.action_add_dialog') }}</ZDialogTitle>
        <ZDialogDescription>
          {{ $t('dictionary.message.action_add_dialog') }}
        </ZDialogDescription>
      </ZDialogHeader>
      <div>
        <FormValidator ref="form" class="grid grid-cols-4 gap-4 py-4">
          <ActionForm :action="action" />
        </FormValidator>
      </div>
      <ZDialogFooter>
        <Action @proceed="store">{{ $t('dictionary.command.action_add') }}</Action>
      </ZDialogFooter>
    </ZDialogContent>
  </ZDialog>
</template>

<script lang="ts">
import { defineComponent, inject } from 'vue';
import Action from '@ui/Action.vue';
import {
  ZDialog,
  ZDialogContent,
  ZDialogDescription,
  ZDialogHeader,
  ZDialogTitle,
  ZDialogFooter,
} from '@shadcn/components/ui/dialog';
import FormValidator from '@ui/FormValidator.vue';
import { ComponentLoadState } from '@/types/ComponentLoadState';
import { ROUTE } from '@/router/routeNames';
import ActionForm from '@ui/Dictionaries/ActionForm.vue';
import { createAction } from '@/api';
import ActionData = App.Data.ActionData;

export default defineComponent({
  components: {
    ActionForm,
    FormValidator,
    Action,
    ZDialog,
    ZDialogContent,
    ZDialogDescription,
    ZDialogHeader,
    ZDialogTitle,
    ZDialogFooter,
  },

  setup() {
    return {
      toast: inject('toast') as (props: any) => void,
    };
  },

  data() {
    return {
      action: {
        has_location: false,
        has_amount: false,
        has_deadline: false,
        has_checkbox: false,
        is_asset_required: false,
      } as ActionData,

      isDialogOpen: true,
      state: 'loading' as ComponentLoadState,
    };
  },

  watch: {
    isDialogOpen() {
      if (!this.isDialogOpen) this.$router.back();
    },
  },

  methods: {
    store(action: any) {
      createAction(this.action)
        .withForm(this.$refs.form as typeof FormValidator)
        .withLoader(action.loader)
        .execute()
        .then(() => {
          this.toast({
            title: this.$t('toasts.type.saved'),
            description: this.$t('action.message.added'),
          });
          this.$router.push({ name: ROUTE.DICTIONARY.ACTIONS });
        });
    },
  },
});
</script>
